export enum raumModel {
  SINGULAR = 'Organisationseinheit',
  PLURAL = 'Organisationseinheiten',
  ROUTE = '/raum',
  ICON = 'mdi-garage',
  ITEM_KEY = 'raum',
  ITEM_KEY_UPDATE = 'raeume'
}
